import { createSelector } from '@ngrx/store'

export const getPathSettingsState = createSelector(
  (state: any) => state.pathSettings,
  (state: any) => state,
)
